import { computed as n, openBlock as a, createElementBlock as u, normalizeClass as d, normalizeStyle as c, createElementVNode as r, createVNode as m } from "vue";
import p from "../../molecules/link/link.vue.js";
import { screenProp as f } from "../../utils/utilsScreen.js";
/* empty css                   */
import h from "../../_virtual/_plugin-vue_export-helper.js";
import v from "../../utils/validators/image.js";
const y = ["poster"], g = ["src", "type"], x = /* @__PURE__ */ Object.assign({
  name: "DsVideoElement"
}, {
  __name: "video-element",
  props: {
    ...f,
    thumbnail: {
      type: Object,
      required: !0,
      validator: (e) => v(e)
    },
    sizes: {
      type: Object,
      default: null
    },
    selfHosted: {
      type: Boolean,
      default: !1
    },
    src: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    extension: {
      type: String,
      default: ""
    },
    fullHeight: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const o = e, s = n(() => {
      var t, i;
      return ((i = (t = o.thumbnail) == null ? void 0 : t[o.screen]) == null ? void 0 : i.src) ?? null;
    }), l = n(() => {
      var t;
      return ((t = o.sizes) == null ? void 0 : t[o.screen]) ?? { width: "auto", height: "auto" };
    });
    return (t, i) => (a(), u("div", {
      class: d(["ds-video", { "ds-video--full-height": e.fullHeight }]),
      style: c(e.fullHeight ? null : { minWidth: `${l.value.width}px`, minHeight: `${l.value.height}px` }),
      "data-j-video": ""
    }, [
      r("video", {
        autoplay: "",
        loop: "",
        muted: "",
        playsinline: "",
        poster: s.value
      }, [
        r("source", {
          src: e.src,
          type: `video/${e.extension}`
        }, null, 8, g),
        m(p, {
          content: e.title,
          url: e.src,
          "open-in-new-window": !0,
          nuxt: !1
        }, null, 8, ["content", "url"])
      ], 8, y)
    ], 6));
  }
}), B = /* @__PURE__ */ h(x, [["__scopeId", "data-v-18f05b7c"]]);
export {
  B as default
};
